// extracted by mini-css-extract-plugin
export default {"flex":"flex_flex__p6L0w"};